import * as React from "react";
import NProgress from "nprogress";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";

import Loader from "../atoms/Loader";
import ManageClubTitle from "../molecules/ManageClubTitle";
import { useGetGrantsByClubQuery } from "../../services/wp";
import { format, parse } from "date-fns";
import { StatusPill } from "../atoms/StatusPill";

interface PropsType extends RouteComponentProps {
    id: any;
}

const ManageClubsGrantsBody = (props: PropsType) => {
    const { data, isLoading, error } = useGetGrantsByClubQuery(props.id);

    const { create_grant_form_link } = useSelector(
        (state: any): any => state.options
    );

    React.useEffect(() => {
        if (isLoading) {
            NProgress.start();
        } else {
            NProgress.done();
        }
    }, [isLoading]);

    return (
        <div className="row manage-clubs-grants-body">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12">
                        <ManageClubTitle
                            title="Grants"
                            ctaText="Apply for a grant"
                            ctaUrl={create_grant_form_link.url}
                        />
                    </div>
                </div>
                <Loader active={isLoading}>
                    {error ? (
                        "An error has occurred. Please try again."
                    ) : data?.length === 0 ? (
                        "The club does not have any grants."
                    ) : (
                        <div className="manage-clubs-grants-body__list">
                            <div className="manage-clubs-grants-body__list__row-divider" />
                            {data?.map((grant, i) => {
                                const createdOn = grant.created_on
                                    ? parse(
                                          grant.created_on,
                                          "yyyy-MM-dd H:mm:ss",
                                          new Date()
                                      )
                                    : null;

                                return (
                                    <React.Fragment key={i}>
                                        <div className="manage-clubs-grants-body__list__item__property manage-clubs-grants-body__list__item__description">
                                            <div className="manage-clubs-grants-body__list__item__description__name">
                                                {grant.name}
                                            </div>
                                            <div className="manage-clubs-grants-body__list__item__description__type">
                                                {grant.grant_type}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-grants-body__list__item__property manage-clubs-grants-body__list__item__applied">
                                            <div className="manage-clubs-grants-body__list__item__label">
                                                Date applied
                                            </div>
                                            <div className="manage-clubs-grants-body__list__item__value">
                                                {createdOn &&
                                                !isNaN(createdOn.valueOf())
                                                    ? format(
                                                          createdOn,
                                                          "d LLL y"
                                                      )
                                                    : null}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-grants-body__list__item__property manage-clubs-grants-body__list__item__requested">
                                            <div className="manage-clubs-grants-body__list__item__label">
                                                Requested
                                            </div>
                                            <div className="manage-clubs-grants-body__list__item__value">
                                                {grant.total_value_requested
                                                    ? `$${grant.total_value_requested}`
                                                    : null}
                                            </div>
                                        </div>
                                        {grant.status === "Approved" &&
                                        grant.total_value_allocated ? (
                                            <div className="manage-clubs-grants-body__list__item__property manage-clubs-grants-body__list__item__allocated">
                                                <div className="manage-clubs-grants-body__list__item__label">
                                                    Allocated
                                                </div>
                                                <div className="manage-clubs-grants-body__list__item__value">
                                                    $
                                                    {
                                                        grant.total_value_allocated
                                                    }
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="manage-clubs-grants-body__list__item__status">
                                            {grant.status ? (
                                                <StatusPill
                                                    status={grant.status}
                                                />
                                            ) : null}
                                        </div>
                                        <div className="manage-clubs-grants-body__list__row-divider" />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}
                </Loader>
            </div>
        </div>
    );
};

ManageClubsGrantsBody.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubsGrantsBody);
